import { render, staticRenderFns } from "./catatankhusus.vue?vue&type=template&id=7943b5ab&"
import script from "./catatankhusus.vue?vue&type=script&lang=js&"
export * from "./catatankhusus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports